<mbs-card
  class="mbs-plan-detail h-auto"
  [customClasses]="'bg-light border-radius-xl-important h-auto'"
  [hasPadding]="false"
  [id]="idPrefix() + '-step-card'"
  [innerBordered]="false"
  [size]="MbsSize.xs">
  @if (error()) {
    <mbs-card-group class="w-100 p-3">
      <mbs-alert
        class="mb-0"
        [icon]="true"
        [type]="popupType.danger">
        {{ error() }}
      </mbs-alert>
    </mbs-card-group>
  }

  <mbs-card-group class="w-100 p-3">
    <div class="form-row">
      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(awsAccounts())"
          [id]="idPrefix() + '-aws-account-select'"
          [items]="awsAccounts()"
          [label]="'mbs-ui:cloud-restore.whereToRestoreStep.awsAccount' | i18next: { format: 'title' }"
          [loading]="loading()"
          [ngModel]="awsAccount()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('awsAccount', $event)"></mbs-select>
      </div>

      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(awsRegions())"
          [id]="idPrefix() + '-aws-region-select'"
          [items]="awsRegions()"
          [label]="'mbs-ui:cloud-restore.whereToRestoreStep.awsRegion' | i18next"
          [loading]="loading()"
          [ngModel]="awsRegion()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('awsRegion', $event)"></mbs-select>
      </div>
    </div>
  </mbs-card-group>

  @if (!isTemporary()) {
    <mbs-card-group class="w-100 p-3">
      <div class="form-row align-items-end">
        <div class="col-11">
          <mbs-select
            [appendTo]="'.modal-content'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [clearable]="false"
            [disabledSelf]="isSelectDisabled(tempDestinations())"
            [id]="idPrefix() + '-temp-destination-select'"
            [items]="tempDestinations()"
            [label]="'mbs-ui:cloud-restore.whereToRestoreStep.tempDestination' | i18next: { format: 'title' }"
            [loading]="loading()"
            [ngModel]="tempDestination()"
            [required]="true"
            [showRequiredMark]="false"
            (ngModelChange)="valueChangeHandler('tempDestination', $event)"></mbs-select>
        </div>

        <div class="col-1 text-end">
          <mbs-button
            type="secondary"
            [disabled]="!awsRegion() || !awsAccount() || loading()"
            [icon]="'fa fa-plus text-lg'"
            (click)="addDestination()"></mbs-button>
        </div>
      </div>
    </mbs-card-group>
  }

  <mbs-card-group class="w-100 p-3">
    <div class="form-row">
      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(instanceTypes())"
          [id]="idPrefix() + '-type-select'"
          [items]="instanceTypes()"
          [label]="'mbs-ui:cloud-restore.whereToRestoreStep.instanceType' | i18next"
          [loading]="loading()"
          [ngModel]="instanceType()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('instanceType', $event)"></mbs-select>
      </div>

      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(subnets())"
          [id]="idPrefix() + '-subnet-select'"
          [items]="subnets()"
          [label]="'mbs-ui:cloud-restore.whereToRestoreStep.subnet' | i18next"
          [loading]="loading()"
          [ngModel]="subnet()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('subnet', $event)"></mbs-select>
      </div>
    </div>
  </mbs-card-group>

  <mbs-card-group class="w-100 p-3">
    <div class="form-row">
      <div class="col-6">
        <mbs-select
          [appendTo]="'.modal-content'"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [disabledSelf]="isSelectDisabled(securityGroups())"
          [id]="idPrefix() + '-security-group-select'"
          [items]="securityGroups()"
          [label]="'mbs-ui:cloud-restore.whereToRestoreStep.securityGroup' | i18next"
          [loading]="loading()"
          [ngModel]="securityGroup()"
          [required]="true"
          [showRequiredMark]="false"
          (ngModelChange)="valueChangeHandler('securityGroup', $event)"></mbs-select>
      </div>

      @if (isTemporary()) {
        <div class="col-6">
          <mbs-select
            [appendTo]="'.modal-content'"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [clearable]="false"
            [disabledSelf]="isSelectDisabled(amis())"
            [id]="idPrefix() + '-ami-select'"
            [items]="amis()"
            [label]="'mbs-ui:cloud-restore.whereToRestoreStep.ami' | i18next"
            [loading]="loading()"
            [ngModel]="ami()"
            [required]="true"
            [showRequiredMark]="false"
            (ngModelChange)="valueChangeHandler('ami', $event)">
            <ng-template
              #mbsSelectOptionTmp
              let-item="item">
              <span
                class="d-flex flex-column w-100"
                style="text-overflow: clip">
                <span class="fw-bold">{{ item.id }}</span>
                <span
                  class="mw-100"
                  style="text-overflow: clip; white-space: normal">
                  {{ item.name.replace(item.id, '').trim() }}
                </span>
              </span>
            </ng-template>
          </mbs-select>
        </div>
      }
    </div>
  </mbs-card-group>
</mbs-card>
